const STEPS = ['نوع حساب', 'اطلاعات', 'تأیید'];

export default function SignupStepper({ currentStep }) {
  return (
    <ol className="signup-stepper" aria-label="مراحل ثبت‌نام">
      {STEPS.map((label, index) => {
        const complete = index < currentStep;
        const current = index === currentStep;
        return (
          <li
            key={label}
            className={`signup-step${complete ? ' is-done' : ''}${current ? ' is-current' : ''}`}
            aria-current={current ? 'step' : undefined}
          >
            <span className="signup-step-node" aria-hidden="true">
              {complete ? <i className="fas fa-check" /> : index + 1}
            </span>
            <span className="signup-step-label">{label}</span>
          </li>
        );
      })}
    </ol>
  );
}
